module.exports = __webpack_public_path__ + "static/media/reportinHomePageBanner.a6a6acdc.svg";